export default "__VITE_ASSET__C0LB2sqb__"